import { render, staticRenderFns } from "./AddNewBranchModal.vue?vue&type=template&id=5c892136&scoped=true"
import script from "./AddNewBranchModal.vue?vue&type=script&lang=js"
export * from "./AddNewBranchModal.vue?vue&type=script&lang=js"
import style0 from "./AddNewBranchModal.vue?vue&type=style&index=0&id=5c892136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c892136",
  null
  
)

export default component.exports